import {
  validateMobilePhone,
  validateLandLinePhone,
  migrationEmptyPhone,
} from '@/utils/validators';
import IconGlyph from '@/bit/components/components.icon-glyph';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';

export const MOBILE_LINE_ACTIONS = {
  NEW: 'NEW',
  PORTABILITY: 'PORTABILITY',
  MIGRATION: 'MIGRA',
};
export const LAND_LINE_ACTIONS = {
  NEW: 'NEW',
  PORTABILITY: 'PORTABILITY',
};
export const SIM_TYPES = {
  SIM: 'SIM',
  ESIM: 'ESIM',
  SIM_ESIM: 'SIM_ESIM',
};
export const SHIPPING_TYPES = {
  SHOP: 'SHOP',
  DELIVERY: 'DELIVERY',
  DIGITAL_DELIVERY: 'DIGITAL_DELIVERY',
};
SHIPPING_TYPES.SHOP_DIGITAL_DELIVERY = `${SHIPPING_TYPES.SHOP}_${SHIPPING_TYPES.DIGITAL_DELIVERY}`;
export const DELIVERY = {
  ID: 'choose_delivery',
  TITLE: '',
  DELIVERY_METHOD: {
    NAME: 'delivery-choicer',
    ID: 'delivery-choicer',
    LABEL: '',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
  }
};
export const DELIVERY_MAPPED_OPTIONS = {
  DELIVERY: 'Envío a domicilio',
  SHOP: 'Recogida en tienda',
}
export const OPERATION = {
  ID: 'choose_number',
  TITLE: 'Línea móvil',
  ACTION_CHOICER: {
    NAME: 'action-choicer',
    ID: 'action-choicer',
    LABEL: 'mobile-line-action-choicer',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        MIGRATION_EMPTY_PHONE: {
          checkFunc: (value) => {
            return migrationEmptyPhone(value, MOBILE_LINE_ACTIONS.MIGRATION);
          },
          message: 'Selecciona un nº movistar',
        },
      },
    },
  },
  CARD_CHOICER: {
    NAME: 'card-choicer',
    ID: 'card-choicer',
    LABEL: '¿Qué tipo de tarjeta necesitas?',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
  },
  PORTABILITY: {
    NAME: 'portabilityPhone',
    ID: 'portabilityPhone',
    LABEL: 'Número que traes de otro operador',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        PORTABILITY_PHONE_FORMAT: {
          checkFunc: validateMobilePhone,
          message:
            'El formato introducido no es válido, deben ser 9 dígitos numéricos.',
        },
      },
    },
    INFO: 'Importante: debes ser el titular del número.',
    MASK: { maxLength: 9, separationLength: 3, separator: ' ' },
  },
  LAND_LINE_PORTABILITY: {
    NAME: 'portabilityLandLine',
    ID: 'portabilityLandLine',
    LABEL: 'Número fijo a portar',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        PORTABILITY_PHONE_FORMAT: {
          checkFunc: validateLandLinePhone,
          message: 'Número no válido',
        },
      },
    },
    MASK: { maxLength: 9, separationLength: 3, separator: ' ' },
  },
};
export const MOBILE_LINE_ACTIONS_TEXTS = {
  [MOBILE_LINE_ACTIONS.NEW]: 'Nº nuevo',
  [MOBILE_LINE_ACTIONS.PORTABILITY]: 'Portabilidad',
  [MOBILE_LINE_ACTIONS.MIGRATION]: 'Nº Movistar',
};
export const MOBILE_LINE_ACTIONS_TAGGING_TEXTS = {
  [MOBILE_LINE_ACTIONS.NEW]: 'alta',
  [MOBILE_LINE_ACTIONS.PORTABILITY]: 'Portabilidad',
  [MOBILE_LINE_ACTIONS.MIGRATION]: 'migra',
};
export const LAND_LINE_ACTIONS_TEXTS = {
  [LAND_LINE_ACTIONS.NEW]: 'Nº nuevo',
  [LAND_LINE_ACTIONS.PORTABILITY]: 'Portabilidad',
};
export const SIM_TYPES_TEXTS = {
  [SIM_TYPES.SIM]: 'SIM',
  [SIM_TYPES.ESIM]: 'eSIM',
};
export const SIM_TYPES_ICONS = {
  [SIM_TYPES.SIM]: (
    <IconGlyph
      id="sim-m"
      color={COLOR_DICTIONARY.GREY5}
      layoutSize={{ width: 12 }}
    />
  ),
  [SIM_TYPES.ESIM]: null,
};
export const SHIPPING_TYPES_TEXT_SHOP =
  'Podrás recoger tu nueva SIM o eSIM en cualquier tienda Movistar.';
export const SHIPPING_TYPES_TEXT_DELIVERY =
  'Recibir en la dirección de facturación';
export const MORE_INFO_TEXT = {
  TEXT: '¿Qué es?',
  MORE_INFO: [
    'La eSIM es una tarjeta SIM que ya viene integrada en tu dispositivo.',
    'Asegúrate antes de seleccionarla que tu dispositivo es compatible.',
  ],
};
